import { Helpers } from '../Modules/Helpers.js'

/**
 * Controls the behavior of the Mobile Main Navigation, including showing and hiding the submenus
 *
 * @type {MobilePageNavigation}
 * @class
 */
export class MobilePageNavigation {
    /**
     * Constructor retrieves all required elements from dom and binds all necessary events
     */
    constructor() {
        this.moblieMenu = document.querySelector('.js__main-nav')

        this.header = document.querySelector('.js__header')

        this.mobileOpener = document.querySelector('.js__main-nav__mobile-opener')
        this.mobileCloser = document.querySelector('.js__main-nav__mobile-closer')
        this.mobileSubOpeners = document.querySelectorAll('.js__main-nav__mobile-sub-opener')
        this.mobileSubClosers = document.querySelectorAll('.js__main-nav__mobile-sub-closer')
        this.mobileSubLinks = document.querySelectorAll('.js__main-nav__sub-opener')

        this.mobileOpener.addEventListener('click', () => this.showMobileNavigation())
        this.mobileCloser.addEventListener('click', () => this.hideMobileNavigation())
        this.mobileSubOpeners.forEach((mobileSubOpener) =>
            mobileSubOpener.addEventListener('click', (event) => this.showMobileSub(mobileSubOpener, event))
        )
        this.mobileSubClosers.forEach((mobileSubCloser) =>
            mobileSubCloser.addEventListener('click', () => this.hideMobileSub(mobileSubCloser))
        )
        this.mobileSubLinks.forEach((mobileSubLink) =>
            mobileSubLink.addEventListener('click', (event) => this.handleSubLinkClick(mobileSubLink, event))
        )
    }

    /**
     * Show the mobile navigation
     *
     * @returns {undefined}
     */
    showMobileNavigation() {
        document.body.classList.toggle('header--mobile-menu-visible')
    }

    /**
     * Hides the mobile navigation
     * Closes all open submenus
     *
     * @returns {undefined}
     */
    hideMobileNavigation() {
        document.body.classList.remove('header--mobile-menu-visible')
        this.header.querySelectorAll('.main-nav__sub').forEach((sub) => {
            sub.classList.remove('main-nav__sub--visible')
        })
    }

    /**
     * Show a submenu inside the mobile menu
     *
     * @param {Element} mobileSubOpener - The element which has been clicked
     * @param {Event} event - The click event
     *
     * @returns {undefined}
     */
    showMobileSub(mobileSubOpener, event) {
        event.preventDefault()
        let sub = mobileSubOpener.parentNode.querySelector('.main-nav__sub')
        sub.classList.add('main-nav__sub--visible')
    }

    /**
     * Hide a submenu inside the mobile menu
     *
     * @param {Element} mobileSubCloser - The element which has been clicked
     *
     * @returns {undefined}
     */
    hideMobileSub(mobileSubCloser) {
        let sub = mobileSubCloser.parentNode.parentNode.parentNode
        sub.classList.remove('main-nav__sub--visible')
    }

    /**
     * Handle the click of the submenu item
     *
     * The nav link by itself would be a link and therefore handle the click. But for the desktop version we have
     * bootstraps collapse event listeners attached to them, which are preventing the default link behavior.
     * Also we can not destroy or prevent the collapse event listener (bootstrap.Collapse is not available).
     *
     * @param {Element} mobileSubLink - The element which has been clicked
     * @param {Event} event - The click event
     *
     * @returns {undefined}
     */
    handleSubLinkClick(mobileSubLink, event) {
        event.stopPropagation()
        event.preventDefault()
        if (Helpers.isOnMobile()) {
            window.location.href = mobileSubLink.href
        }
    }
}
